<template>
  <div>
    <FrameHeader/>

    <div class="p-5 mx-auto" style="max-width: 550px;">

      <h2 class="tac mb-5">
        {{lg('',{
          en: 'Edit Profile',
          zh: '编辑个人主页',
        })}}
      </h2>

      <div class="media">

        <label id="avatar-upload-label" class="label-with-input-file-hidden">
          <span :class="['ui-avatar size-120 cp',{'on-loading':sync_avatar.status_uploading}]">
            <img :key="sync_avatar.img_url" :src="sync_avatar.img_url || $store.state.user.local_user.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
          </span>

          <span 
            class="sp-upload-btn btn btn-sm btn-outline-primary cp small abs" 
            style="min-width: 120px;"
            >
            {{lg('',{
              en: 'Choose file',
              zh: '上传头像',
            })}}
          </span>

          <CpUniUpload
            :sync_obj="sync_avatar"
            :conf="{
              target_folder_name: 'jgn_avatar/',
              filetype_allowed: ['jpg','jpeg','png','webp','gif'],
              compress_cfg: {
                maxWidth: 150,
                maxHeight: 150,
              },
            }"
          />
        </label>

        <div class="media-body pl-4 pt-2 small">
          <div>
            {{lg('',{
              en: 'We recommend an image of at least 400x400.',
              zh: '建议使用至少400x400的图片，',
            })}}
            <br>
            {{lg('',{
              en: 'Gifs work too.',
              zh: '也可以上传Gifs。',
            })}}
          </div>
        </div>
      </div>

      <div class="pc-none pt-4 mt-2">
        <!-- for style -->
      </div>

      <div>
        <div class="mt-4">
          <h5 class="b">
            {{lg('',{
              en: 'Display name',
              zh: '用户名',
            })}}*
          </h5>
          <input 
            v-model="form.username" 
            type="text" 
            class="form-control"
            placeholder="Enter your display name"
          >
          <small class="t-gray">
            {{lg('',{
              en: 'requered. Only letters, number, underscores and emojis',
              zh: '*标为必填项。可输入字母、数字、下划线和emoji',
            })}}
          </small>
        </div>

        <div v-if="0" class="mt-3">
          <h5 class="b">
            {{lg('email')}}
          </h5>
          <input 
            v-model="form.email" 
            type="text" 
            class="form-control"
            placeholder="example@email.com"
          >
          <small class="t-gray">
            {{lg('',{
              en: 'Be the first to know when new NFTs are added!',
              zh: '第一时间了解最新的收藏品添加',
            })}}
          </small>
        </div>

        <div class="mt-3">
          <h5 class="b">
            {{lg('',{
              en: 'Bio',
              zh: '个人简介',
            })}}
          </h5>
          <input 
            v-model="form.bio" 
            type="text" 
            class="form-control"
            placeholder="Tell us about yourself in a few words"
          >
          <small class="t-gray">
            {{lg('',{
              en: 'URLs are allowed',
              zh: '也可添加URL',
            })}}
          </small>
        </div>

        <div class="mt-3 tac">
          <span @click="save()" class="btn btn-primary btn-round">
            {{lg('',{
              en: 'Update Profile',
              zh: '更新个人资料',
            })}}
          </span>
        </div>
      </div>
    </div>

    <FrameFooter/>
  </div>
</template>

<script>
import bus from '@/bus.js'
import {mapActions} from 'vuex'

export default {
  name: 'blockProfile',
  components: {},
  props: [
    // cfg : {auto_call_login: true,}
    'cfg',
  ],
  data() {
    return {

      sync_avatar: {
        img_url: '',
        status_uploading: false,
        status_upload_percent: 0,
      },

      form: {
        username: '',
        email: '',
        bio: '',
        imageURL: '',
      },
    }
  },
  computed: {
    local_user(){
      let v = this
      return v.$store.state.user.local_user
    },
  },
  watch: {
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },
    'sync_avatar.img_url'(val){
      this.form.imageURL = val
    },
  },
  methods: {

    ...mapActions([
      'accountSign',
    ]),

    async save(){
      let v = this
      let address_my = v.$store.state.web3.account
      let sig = await v.accountSign(address_my)


      let form = {
        address: address_my,
        sign: sig,
        username: v.form.username,
        email: v.form.email,
        bio: v.form.bio,
        imageURL: v.form.imageURL,
      }

      v.api('user_update',form,{
        vue: v,
        done_run_function: ['getUserInfo'],
      }).then(function(){
        v.status_poppad_userinfo = false
      })
    },

    fillForm(){
      let v = this

      v.form.username = v.local_user.username
      v.form.email = v.local_user.email
      v.form.bio = v.local_user.bio
      v.form.imageURL = v.local_user.imageURL
    },

    async getUserInfo(){
      let v = this
      let address_my = v.$store.state.web3.account
      let address_user = v.$store.state.user.local_user.address

      let res = await v.uniCheckUserLogin()

      v.fillForm()

      if(!res){

        // call signin pad
        if((v.cfg && v.cfg.auto_call_login) && address_my && !address_user){
          bus.headervue.mark_sign_ui_call += 1
        }
      }
    },

    run(){
      let v = this
      
      this.getUserInfo()
      this.fillForm()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .sp-upload-btn{

    @media(min-width: 788px){
      bottom: 10px; left: 140px; 
    }
    @media(max-width: 788px){
      bottom: -40px; left: 0px; 
    }
  }
</style>